import React from 'react'
import { NavLink as RouterLink } from 'react-router-dom'
import { Box, Drawer, Link, Typography } from '@mui/material'
import { type DrawerProps } from '@mui/material'
import Navigation from '../Navigation'
import MenuIcon from '@mui/icons-material/Menu'
import LoginIcon from '@mui/icons-material/AccountCircleRounded'
import CloseIcon from '@mui/icons-material/Close'
import { red } from '../../../../theme/customColors'
import { useSelector } from 'react-redux'
import { PATH } from '../../../../routes/constant'
import { type IUserProfile } from '../../../../redux/api/types'

const DrawerComponent: React.FC<DrawerProps> = () => {
  const [mobileOpen, setMobileOpen] = React.useState(false)
  const mode = useSelector((state: any) => state.modeState)
  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState)
  }
  const user: IUserProfile = useSelector((state: any) => state.userState.user)
  return (
    <>
      <Box
        onClick={handleDrawerToggle}
        sx={{ cursor: 'pointer' }}
      >
        <MenuIcon/>
      </Box>
      <Drawer
        variant="temporary"
        open={mobileOpen}
        ModalProps={{
          keepMounted: true
        }}
        sx={{
          '.MuiDrawer-paper': {
            width: '100%'
          }
        }}
      >
        <CloseIcon
          onClick={handleDrawerToggle}
          sx={{
            cursor: 'pointer',
            fontSize: '31px',
            position: 'absolute',
            right: '20px',
            top: '20px',
            zIndex: 2
          }}
        />
        <Box sx={{ borderBottom: '1px solid #DFE3EB', ml: '8px', p: '30px 0 15px 10px' }}>
          <LoginIcon sx={{ color: 'rgba(195, 202, 217, 1)', height: '55px', width: '55px' }} />
          <Typography
            component="div"
            sx= {{
              flexGrow: 1,
              color: '#6B7A99',
              fontSize: '14px',
              fontWeight: 700,
              letterSpacing: 0.01,
              pl: '10px'
            }}
          >
            {user?.firstName} {user?.secondName}
          </Typography>
        </Box>
        <Navigation setMobileOpen={setMobileOpen}/>
        <Box
          sx={{
            borderTop: '1px solid #DFE3EB',
            display: 'flex',
            flexDirection: 'column',
            mr: '8px',
            p: '30px 10px 15px 0'
          }}
        >
          <Link
            onClick={handleDrawerToggle}
            component={RouterLink}
            to={
              // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
              `${mode.isWp === true ? `${process.env.REACT_APP_HOSTNAME}${PATH.ACCOUNT}` : PATH.ACCOUNT}`
            }
            sx= {{
              color: '#7D8FB3',
              fontSize: '14px',
              fontWeight: 700,
              ml: '18px',
              p: '10px'
            }}
            underline="none"
          >Account</Link>
           <Link
            onClick={handleDrawerToggle}
            component={RouterLink}
            to={
              // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
              `${mode.isWp === true ? `${process.env.REACT_APP_HOSTNAME}${PATH.ACCOUNT}` : PATH.ACCOUNT}`
            }
            sx= {{
              alignItems: 'center',
              color: '#7D8FB3',
              display: 'flex',
              fontSize: '14px',
              fontWeight: 700,
              justifyContent: 'space-between',
              ml: '18px',
              p: '10px'
            }}
            underline="none"
          >Notifications
            <Box
              component='span'
              sx={{ background: 'rgba(230, 46, 46, 0.2)', borderRadius: '5px', color: red[500], p: '2px 5px' }}
            >
            23
            </Box>
          </Link>
        </Box>
      </Drawer>
    </>
  )
}

export default DrawerComponent
